export default __webpack_public_path__ + "static/media/breakin-away.9d7e693c.mp3";